import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import layout from '../styles/layout';
import palette from '../styles/palette';
import { Quantum } from '../icons';

const useStyles = makeStyles(({ typography }) => ({
  header: {
    backgroundColor: palette.slate,
    display: 'flex',
    height: typography.pxToRem(layout.header.height),
    padding: `0 ${typography.pxToRem(28)}`,
  },
}));

const Header = ({ children }) => {
  const classes = useStyles();
  return (
    <Box className={classes.header}>
      <Quantum />
      <Box
        flexGrow={1}
        justifyContent="flex-end"
        display="flex"
        alignItems="center"
      >
        {children && { ...children }}
      </Box>
    </Box>
  );
};

export default Header;
